import { render, staticRenderFns } from "./OverviewMappingSalesAssignment.vue?vue&type=template&id=144ef233"
import script from "./OverviewMappingSalesAssignment.vue?vue&type=script&lang=js"
export * from "./OverviewMappingSalesAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports